module.exports = __webpack_public_path__ + "static/media/washington-dc-59.087395cc.jpg";